/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DealJournalEntriesInner
 */
export interface DealJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof DealJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DealJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'invalidTaxCodeCause': DealJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DealJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof DealJournalEntriesInner
     */
    'description': string | null;
}

export const DealJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type DealJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof DealJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof DealJournalEntriesInnerInvalidTaxCodeCauseEnum];


